const BLANK_VALUES = Object.freeze({
  // Checkboxes have a default value of false to be unchecked.
  checkbox: false,
});

export const FIELD_BLANK_VALUES = Object.freeze({
  isStaticIPEnabled: BLANK_VALUES.checkbox,
});
